import { FC } from 'react';
import { cn, Image } from "@heroui/react";

export type LogoVariant = 'text' | 'full' | 'iconOnly';

interface LogoProps {
  variant?: LogoVariant;
  className?: string;
}

export const Logo: FC<LogoProps> = ({ variant = 'full', className }) => {
  const renderText = () => (
    <span className="text-2xl text-secondary">
      bite<span className="font-bold text-primary">critic</span>
    </span>
  );

  const renderIcon = () => {
    const size = variant === 'full' ? 64 : 16;
    return (
      <Image
        alt="bitecritic"
        src="/logo.png"
        className={`w-${size} h-${size} min-w-${size} min-h-${size}`}
        width={size}
        height={size}
      />
    );
  };

  if (variant === 'text') {
    return (
      <div className={cn("flex items-center", className)}>
        {renderText()}
      </div>
    );
  }

  if (variant === 'iconOnly') {
    return (
      <div className={cn("flex items-center", className)}>
        {renderIcon()}
      </div>
    );
  }

  return (
    <div className={cn("flex items-center", className)}>
      {renderIcon()}
      {renderText()}
    </div>
  );
};

export default Logo; 